import SettingsQuestionsForm from '../settings-questions-form/SettingsQuestionsForm';

const SettingsQuestionsAddPage = (props) => {
  return (
    <div className='settings-question-add-page'>
      <div className='row'>
        <h4>New question</h4>
      </div>
      <div className='row'>
        <SettingsQuestionsForm {...props} />
      </div>
    </div>
  );
};

export default SettingsQuestionsAddPage;
